import { Inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { GeneralService } from '../general.service';
@Injectable({
  providedIn: 'root'
})
export class TenantCustomService extends GeneralService {
  serviceName = 'TenantCustomService';
  constructor(
    public http: HttpClient,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/ten/custom');
  }
  getDataList() {
    return this.http.get(this.httpBase + "/ten/custom")
  }
  saveCustom(item) {
    return this.http.put(this.httpBase + '/ten/custom', item);
  }
  getTypeList() {
    return this.http.get(this.httpBase + "/ten/custom/field/type").pipe(map(res => res ? res['data'] : []));
  }
  getModelList() {
    return this.http.get(this.httpBase + "/ten/custom/model/type").pipe(map(res => res ? res['data'] : []));
  }
  getmodelType(modelType) {
    return this.http.get(this.httpBase + '/ten/custom/model/' + modelType).pipe(map(res => res ? res['data'] : []));
  }
  getCustomById(customId) {
    return this.http.get(this.httpBase + '/ten/custom/' + customId).pipe(map(res => res ? res['data'] : []));
  }

  deleteCustom(customId) {
    return this.http.delete(this.httpBase + '/ten/custom/' + customId).pipe(map(res => res ? res['data'] : []));
  }
}



